export function getSafeRedirectUrl(redirect: string | undefined): string {
	if (!redirect) {
		return '/';
	}

	// Only allow relative paths — block protocol-relative URLs and absolute URLs
	if (!redirect.startsWith('/') || redirect.startsWith('//')) {
		return '/';
	}

	return redirect;
}
